<template>
  <UlDialog
    v-model="dialog"
    header-type="information"
    :left-header-icon="formSent ? 'icons/check_circle.svg' : 'icons/person-happy.svg'"
    :title="formSent ? $t('feedback.thankYou.title') : $t('feedback.title')"
    :buttons="feedbackButtons"
  >
    <template #text>
      <FeedbackContent />
    </template>
  </UlDialog>
</template>

<script>
import FeedbackContent from '@/feature/feedback/components/FeedbackContent.vue';
import { useFeedback } from '@/feature/feedback/composables/useFeedback.js';
import dialogGtm from '@/mixins/dialogGtm';

export default {
  name: 'FeedbackForm',
  components: { FeedbackContent },
  mixins: [dialogGtm],
  setup() {
    const { formSent, feedbackButtons, setFormSent, resetFeedbackTimer } = useFeedback();
    return { formSent, feedbackButtons, setFormSent, resetFeedbackTimer };
  },
  computed: {
    dialog: {
      get() {
        return this.$store.state.profile.dashboard.dialog === 'feedback';
      },
      set(value) {
        this.$store.commit('profile/dashboard/setDialog', value);
      }
    }
  },
  watch: {
    dialog(newValue) {
      if (newValue) {
        this.setFormSent(false);
        this.dialogChanged('feedback', true);
      } else {
        if (this.currentPath === 'dashboard') {
          this.resetFeedbackTimer();
        }
        this.dialogChanged('feedback', false);
      }
    }
  }
};
</script>
